import { useQueryClient } from "@tanstack/react-query";

type QueryKey = string | readonly unknown[];

/**
 * 通用 invalidate hook，可批量 invalidate 多个 queryKey
 */
export function useInvalidateResources() {
  const queryClient = useQueryClient();

  return (keys: QueryKey[]) => {
    keys.forEach((key) => {
      queryClient.invalidateQueries({
        queryKey: Array.isArray(key) ? key : [key],
      });
    });
  };
}
